<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.95 17.314L5 12.364L6.414 10.95L9.9515 14.4835L9.95 14.485L18.435 6L19.849 7.414L11.364 15.9L9.951 17.313L9.95 17.314Z" :fill="fill" />

    <rect
      v-if="underline"
      width="16"
      height="1"
      transform="matrix(1 0 0 -1 4 19)"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsCheckUnderline'
})

defineProps({
  underline: {
    type: Boolean,
    default: true
  },
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
